import React from 'react';
import ProductForm from './ProductForm';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: (productoId: number, productoLocalData: any) => void;
    initialBarcode?: string;
    subcategorias: any[];
    ubicaciones: any[];
}

const ModalCreacionProductoRapida: React.FC<ModalProps> = ({ isOpen, onClose, onSuccess, initialBarcode = '' }) => {
    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
            <div style={{
                backgroundColor: 'white', padding: '1.5rem', borderRadius: '0.5rem', width: '90%', maxWidth: '800px',
                maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
            }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', borderBottom: '1px solid #e5e7eb', paddingBottom: '0.5rem' }}>
                    Creación Rápida de Producto
                </h3>

                {/* Reusing the exact same form component from the Products page */}
                <ProductForm
                    onClose={onClose}
                    onSuccess={(msg: string, newProductData?: any) => {
                        if (newProductData) {
                            onSuccess(newProductData.id, newProductData);
                        } else {
                            // If it doesn't return data, just close for now.
                            onClose();
                        }
                    }}
                    initialBarcode={initialBarcode}
                />
            </div>
        </div>
    );
};

export default ModalCreacionProductoRapida;
